import { FormattedMessage } from 'react-intl'

export const DefaultErrorSteps = () => (
	<>
		<FormattedMessage id='flow.errorResolveStepsTitle' defaultMessage='You can try these steps if the issue persists' />
		<ol>
			<li>
				<FormattedMessage
					id='flow.errorResolveStepsOne'
					defaultMessage='Try to re-open the link and login again with the included password'
				/>
			</li>
			<li>
				<FormattedMessage id='flow.errorResolveStepsTwo' defaultMessage='Try again a later' />
			</li>
		</ol>
		<FormattedMessage
			id='flow.errorResolveStepsEnd'
			defaultMessage='If the issue still persists after trying these steps, please reach out to your advisor for help.'
		/>
	</>
)
